import React from "react";
// import { ImCross } from "react-icons/im";
import { FaTrash } from "react-icons/fa";
import { useDispatch } from "react-redux";
// import {
//   deleteItem,
//   drecreaseQuantity,
//   increaseQuantity,
// } from "../../redux/orebiSlice";
import { FaCirclePlus, FaCircleMinus  } from "react-icons/fa6";

const ProductComparisonItem = ({ item }) => {
  const dispatch = useDispatch();
  return (
    <table class="w-full divide-y divide-gray-200 mt-10">
          <thead class="bg-gray-100">
            <tr>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                Feature
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                Product B
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr>
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                Price
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                Rp. {item.price}
              </td>
            </tr>
            <tr>
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                Spec
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <div class="w-3/4 ...">
                  <div class="whitespace-normal ...">{item.desc}</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
  );
};

export default ProductComparisonItem;
